/// Port of `get_tiger_diagnostic_severity_colour()` from
/// `libTiger/mwins_utils.cpp:828`. Returns the default-colour string for a
/// given severity bitmask value. Runtime ini-file overrides are not ported.
///
/// Severity values come from `libTiger/pc_common.h:94-121`.
export function severityColor(severity: number): string {
  switch (severity) {
    case 0x00:
      return "black"; // NO_SEVERITY
    case 0x01:
      return "brown"; // TRIP
    case 0x02:
      return "red"; // CRITICAL
    case 0x04:
      return "orange"; // FAULT
    case 0x08:
      return "purple"; // WARNING
    case 0x10:
      return "darkcyan"; // EVENT — CSS "cyan" is too bright on white
    case 0x20:
      return "darkgreen"; // INFORMATION
    case 0x40:
      return "blue"; // COLLECTION
    case 0x80:
      return "black"; // TITLE
    case 0x100:
    case 0x400:
    case 0x1000:
    case 0x4000:
    case 0x10000:
    case 0x20000:
      return "#7f7f7f"; // *_ON / SENTINEL_TRIP — grey50
    case 0x200:
    case 0x800:
    case 0x2000:
    case 0x8000:
    case 0x40000:
      return "#bfbfbf"; // *_OFF / SENTINEL_ALARM — grey75
    default:
      return "black";
  }
}
